// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__di4oZ","Open":"SideDrawer_Open__2HVz0","Close":"SideDrawer_Close__2SCvn","Logo":"SideDrawer_Logo__3m3FU"};